<div class="widget">
  <div class="amSuite-widget-header">
    {{ 'widgets.user-activities.title' | translate }}
    @if (modify) {
    <a href="javascript:void(0)" (click)="actpop()" class="modify-btn"
      pTooltip="{{'widgets.user-activities.edit' | translate}}">
      <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
    </a>
    }
    @if (!modify) {
    <small class="date-font"><i>({{initialDate | dateMoment:shortDate}} -
        {{finalDate | dateMoment:shortDate}})</i></small>
    }
  </div>

  <div class="amSuite-widget-block height-auto">
    @if (activities && activities.length > 0) {
    <div>
      @for (act of activities; track $index) {
      <div>
        <div class="row widgetBodyBoxBlue">
          <div class="col-sm-1 col-md-1 col-lg-1" style="display: flex; justify-content: center;">
            <p-tag [severity]="stateConfig[act.workingState].severity" 
                  [icon]="stateConfig[act.workingState].icon + ' font-semibold'" 
                  [rounded]="true" 
                  styleClass="p-tag-outlined">
            </p-tag>
          </div>
          <div class="col-sm-11 col-md-11 col-lg-11">
            <div class="title-row">
              <a class="title-link" href="javascript:void(0)" (click)="modify ? '' : onSelectActivity(act)">
                <h6 class="title-text">{{ act.subject }}</h6>
              </a>
            </div>
            <div>
              <label style="font-weight: bold; font-size: 13px;">{{ act.activityTypology.name }}</label>
            </div>
            <div style="font-size: 13px;">
              {{ act.date | dateMoment:shortDate }}
            </div>
            <div style="margin-top: 2px;">
              @for (p of act.parties; track $index) {
              <span class="activityWidgetDetails">{{ p.partyName }}</span>
              }
            </div>
          </div>
        </div>
      </div>
      }
    </div>
    }
    @if (activities && activities.length === 0) {
    <div>
      <div class="row noResultsLabel"> {{ 'app.noData' | translate }}</div>
    </div>
    }
    @if (!activities) {
    <div>
      <div class="m-0 o-0">
        <div class="mb-3">
          <div class="flex">
            <div style="flex: 1" class="skeletonClass">
              <p-skeleton width="100%" styleClass="mb-2"></p-skeleton>
              <p-skeleton width="75%"></p-skeleton>
            </div>
          </div>
        </div>
        <div class="mb-3">
          <div class="flex">
            <div style="flex: 1" class="skeletonClass">
              <p-skeleton width="100%" styleClass="mb-2"></p-skeleton>
              <p-skeleton width="75%"></p-skeleton>
            </div>
          </div>
        </div>
        <div class="mb-3">
          <div class="flex">
            <div style="flex: 1" class="skeletonClass">
              <p-skeleton width="100%" styleClass="mb-2"></p-skeleton>
              <p-skeleton width="75%"></p-skeleton>
            </div>
          </div>
        </div>
        <div>
          <div class="flex">
            <div style="flex: 1" class="skeletonClass">
              <p-skeleton width="100%" styleClass="mb-2"></p-skeleton>
              <p-skeleton width="75%"></p-skeleton>
            </div>
          </div>
        </div>
      </div>
    </div>
    }
  </div>
</div>
